import React from 'react';
import draggable from './draggable';
import { Track, StyledSlider } from './styledComponents';

const Slider = ({ startUpdates }) => (
  <StyledSlider
    onMouseDown={startUpdates}
    onTouchStart={startUpdates}>
    <Track />
  </StyledSlider>
);

export default draggable(Slider, 360);
